import { render, staticRenderFns } from "./OidcProviderCard.vue?vue&type=template&id=11d71676&scoped=true&"
import script from "./OidcProviderCard.vue?vue&type=script&lang=ts&"
export * from "./OidcProviderCard.vue?vue&type=script&lang=ts&"
import style0 from "./OidcProviderCard.vue?vue&type=style&index=0&id=11d71676&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d71676",
  null
  
)

export default component.exports